module.exports = __webpack_public_path__ + "static/img/0001眼保健.88facb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/0001眼保健.jpg
// module id = BpyT
// module chunks = 0